export const userHelper = {
  loginUser,
  logoutUser
}

function loginUser (partner, professional, partnerName, partnerPhone) {
  const data = JSON.stringify({ partner, professional, partnerName, partnerPhone })
  localStorage.setItem('userData', data)
};

function logoutUser () {
  localStorage.removeItem('userData')
  window.location.href = '/login'
};
